import React, { useEffect, useState } from 'react';

import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Layout, Menu, theme, Popconfirm } from 'antd';
import { observer } from 'mobx-react-lite';

import {
  LogoutOutlined
} from '@ant-design/icons';

import generateItems from '../../config/index.jsx';
import useStore from '../../store';

import './index.scss';

const { Header, Sider, Content } = Layout;

const App = () => {
  
  const {
    token: { colorBgContainer }
  } = theme.useToken();
  
  const { pathname } = useLocation();
  const { UserStore, LoginStore } = useStore();
  const navigate = useNavigate();
  
  const [ items, setItems ] = useState(0);
  
  useEffect(() => {
    async function fetchData () {
      await UserStore.getUserInfo();
      const userInfo = UserStore.userInfo;
      const res = generateItems(userInfo);
      setItems(res);
    }
    fetchData();
  }, [ UserStore ]);
  
  const onConfirm = () => {
    LoginStore.logout();
    UserStore.logout();
    navigate('/login', { replace: true });
  }

  return (
    <Layout className='layout'>
      <Sider trigger={null} className='sider'>
        <div className='logo'>
          <svg width="124" height="14" viewBox="0 0 124 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0.22168V2.72275H4.14485V13.7253H7.48391V2.72275H11.6315V0.22168H0Z" fill="white"></path>
            <path d="M44.6171 0.220947V9.0197L38.9407 0.220947H35.3809V13.7245H38.4412V5.00489L44.3963 13.7518H47.6802V0.220947H44.6171Z" fill="white"></path>
            <path d="M69.6124 0.220947L66.2733 9.70702L64.8522 5.96768L66.8556 0.220947H64.2699L63.489 2.91567L62.6004 0.220947H59.5373L61.9878 6.16133L60.6245 9.59792L57.1999 0.220947H53.7505L59.2034 13.9973H61.4303L63.3234 9.21335L65.2137 13.9973H67.5786L72.7555 0.220947H69.6124Z" fill="white"></path>
            <path d="M102.242 8.08691V13.7246H98.9306V8.08691L94.7002 0.220947H98.2904L100.824 4.97762L103.495 0.220947H106.834L102.242 8.08691Z" fill="white"></path>
            <path d="M121.652 3.71206C120.234 2.97019 119.425 2.77654 118.117 2.77654C117.256 2.77654 116.42 3.05202 116.42 3.71206C116.42 4.59303 117.7 5.14397 119.091 5.85856C121.095 6.90318 122.819 7.4814 122.819 10.0397C122.819 12.6254 120.843 14 117.642 14C115.333 14 113.887 13.3945 112.3 12.5708L113.746 9.98519C115.082 10.7271 116.307 11.1962 117.67 11.1962C118.503 11.1962 119.367 10.948 119.367 10.1788C119.367 9.10695 116.723 8.08962 116.028 7.73232C113.608 6.41223 112.799 5.58582 112.799 3.90844C112.805 1.09916 115.17 0 118.203 0C120.206 0 121.373 0.357296 123.073 1.09916L121.652 3.71206Z" fill="white"></path>
            <path d="M27.2517 11.0544H18.9344V13.7519H27.2517V11.0544Z" fill="white"></path>
            <path d="M27.2517 5.63757H18.9344V8.33502H27.2517V5.63757Z" fill="white"></path>
            <path d="M27.2517 0.220947H18.9344V2.9184H27.2517V0.220947Z" fill="white"></path>
            <path d="M85.3505 0.220947H82.4006L77.196 13.7246H80.7586L83.9018 3.90573L86.9897 13.7246H90.5523L85.3505 0.220947Z" fill="white"></path>
          </svg>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[pathname]}
          selectedKeys={[pathname]}
          items={items}
        >
        </Menu>
      </Sider>
      <Layout className="site-layout">
        <Header style={{ padding: 0, background: colorBgContainer }}>
          <span className="user-name">{ UserStore.userInfo.username }</span>
          <span className="user-logout">
            <Popconfirm
              onConfirm={onConfirm}
              title="是否确认退出？" okText="退出" cancelText="取消">
              <LogoutOutlined /> 退出
            </Popconfirm>
          </span>
        </Header>
        <Content
          style={{
            margin: '24px 16px 0px',
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
            overflowY: 'auto'
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  )
}

export default observer(App);